/**
 * SelectionBar - substitui o composer enquanto há mensagens selecionadas,
 * como no WhatsApp: "N selecionadas" à esquerda e as ações à direita
 * (Encaminhar, Chamar o Agente, cancelar). Antes o único jeito de encaminhar
 * era um ícone no canto superior direito que o cliente não achava
 * (Gelo Americano, 07/10/2026). Compartilhado pelos 3 shells.
 *
 * Props: { count, max, onForward, onAskAgent (opcional), onCancel, colors,
 *          forwardDisabledReason }
 */
import React from 'react';
import { X, Forward, Sparkles } from 'lucide-react';

const Btn = ({ icon: Icon, label, onClick, primary, colors, disabled, title }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    title={title || label}
    style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      height: 36, padding: '0 14px', borderRadius: 18, fontSize: 13, fontWeight: 600,
      border: primary ? 'none' : `1px solid ${colors.borderColor}`,
      backgroundColor: primary ? colors.accentPrimary : colors.bgPrimary,
      color: primary ? '#fff' : colors.textPrimary,
      cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
      whiteSpace: 'nowrap',
    }}
  >
    <Icon size={16} />
    <span>{label}</span>
  </button>
);

const SelectionBar = ({ count = 0, max, onForward, onAskAgent, onCancel, colors, forwardDisabledReason = '' }) => {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px',
      backgroundColor: colors.bgSecondary, borderTop: `1px solid ${colors.borderColor}`,
      minHeight: 60,
    }}>
      <button
        type="button"
        onClick={onCancel}
        title="Cancelar seleção"
        style={{
          width: 36, height: 36, borderRadius: '50%', border: 'none',
          backgroundColor: 'transparent', color: colors.textSecondary, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}
      >
        <X size={20} />
      </button>
      <div style={{ flex: 1, minWidth: 0, fontSize: 14, color: colors.textPrimary, fontWeight: 500 }}>
        {count} {count === 1 ? 'selecionada' : 'selecionadas'}
        {max ? <span style={{ color: colors.textTertiary, fontWeight: 400 }}> · até {max}</span> : null}
      </div>
      {onAskAgent && (
        <Btn icon={Sparkles} label="Chamar o Agente" onClick={onAskAgent} colors={colors} />
      )}
      <Btn
        icon={Forward}
        label="Encaminhar"
        onClick={onForward}
        primary
        colors={colors}
        disabled={!!forwardDisabledReason || count === 0}
        title={forwardDisabledReason || 'Encaminhar para outros contatos'}
      />
    </div>
  );
};

export default SelectionBar;
